export default {"src":"/_next/static/media/4x4.91b17a88.svg","height":256,"width":256,"blurWidth":0,"blurHeight":0};